import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import classNames from 'classnames/bind';

import {
  getFilterOpenedState,
  getFilterOptionsCount,
  getNoOptionsCountersFlag,
  getFilterOptionsToShowCount,
  getFilterName,
  getFilterOptions,
} from 'store/ProductCatalog/filters/selectors';
import { toggleFilterOption } from 'store/ProductCatalog/filters/actions';

import ShowAllButton from '../ShowAllButton';
import FiltersHeader from '../FiltersHeader';
import FiltersOption from '../FiltersOption';
import styles from './styles.pcss';

const cx = classNames.bind(styles);

export function CommonFilterLayout({
  isMobile,
  className,
  isOpen,
  optionsToShowCount,
  optionsCount,
  name,
  slug,
  options,
  type,
  onOptionToggle,
  notShowOptionsCounters,
}) {
  // conditions for 'show all options' button
  const moreOptionsToShow = optionsCount - optionsToShowCount > 0;
  const renderCount = moreOptionsToShow ? optionsToShowCount : optionsCount;
  // ===
  return (
    <div className={cx('filter', className, isMobile && 'mobile')}>
      <FiltersHeader {...{ isMobile, name, slug, isOpen }} />
      {isOpen &&
        optionsCount !== 0 &&
        options
          .slice(0, renderCount)
          .map((option) => (
            <FiltersOption
              name={option.name}
              notShowOptionsCounters={notShowOptionsCounters}
              slug={`${slug}_${option.slug}`}
              count={option.productsCount}
              key={option.slug}
              color={option.color}
              isDisabled={!option.isChecked && option.isDisabled}
              isChecked={option.isChecked}
              type={type}
              onChange={() => onOptionToggle({ filterSlug: slug, optionSlug: option.slug })}
            />
          ))}
      {isOpen && moreOptionsToShow ?
        <ShowAllButton {...{ isMobile, slug }} />
      : null}
    </div>
  );
}

CommonFilterLayout.propTypes = {
  isMobile: PropTypes.bool,
  className: PropTypes.string,
  isOpen: PropTypes.bool,
  optionsToShowCount: PropTypes.number,
  optionsCount: PropTypes.number,
  name: PropTypes.string,
  slug: PropTypes.string,
  type: PropTypes.string,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      slug: PropTypes.string,
      productsCount: PropTypes.number,
      isDisabled: PropTypes.bool,
      color: PropTypes.string, // isOptional, for color type only
    }),
  ),
  onOptionToggle: PropTypes.func,
  notShowOptionsCounters: PropTypes.bool,
};

const mapStateToProps = (state, ownProps) => ({
  isOpen: getFilterOpenedState(state, ownProps.slug),
  optionsToShowCount: getFilterOptionsToShowCount(state, ownProps.slug),
  optionsCount: getFilterOptionsCount(state, ownProps.slug),
  notShowOptionsCounters: getNoOptionsCountersFlag(state),
  name: getFilterName(state, ownProps.slug),
  options: getFilterOptions(state, ownProps.slug),
});

const mapDispatchToProps = {
  onOptionToggle: toggleFilterOption,
};

const CommonFilter = connect(mapStateToProps, mapDispatchToProps)(CommonFilterLayout);
CommonFilter.propTypes = {};
export default CommonFilter;
